/* eslint-disable react-refresh/only-export-components */

/*DEVOPS-FABIO apenas para gatilho da esteira de desenvolvimento*/
import { createRoot } from 'react-dom/client'
import { HashRouter as Router } from 'react-router-dom'

import { Alert, Auth, Confirmation } from '@/modules'
import { ObserverContextProvider } from '@/modules/observer'
import { Dialog } from '@/modules/dialog'

import App from '@/App'

import { GlobalStyle } from './assets/global-style'
import { MenuContextProvider } from './components/layout/menu.context'
import { Envs, OptionalEnvs } from './configs/env'
import { BuildProvidersTree } from './utils/provider-tree'

const isLocal = process.env.REACT_APP_ENV === 'local'
Envs.forEach((expectedEnv: string): void => {
  // Em ambientes AWS (dev/prod), credenciais são opcionais (usam IAM Role)
  const isOptionalInCloud = OptionalEnvs.includes(expectedEnv)
  const shouldSkip = !isLocal && isOptionalInCloud

  if (!shouldSkip && !process.env[expectedEnv]) {
    throw new Error(`Variável ${expectedEnv} é obrigatória`)
  }
})

const ProvidersTree = BuildProvidersTree([
  [
    Router,
    {
      future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      },
    },
  ],
  [ObserverContextProvider, {}],
  [MenuContextProvider, {}],
  [Confirmation.Provider, {}],
  [Alert.Provider, {}],
  [Auth.Provider, {}],
  [Dialog.Provider, {}],
])

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <ProvidersTree>
    <GlobalStyle />
    <App />
    <Alert.Component />
    <Confirmation.Component />
    <Dialog.Component />
  </ProvidersTree>,
)
